import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Heading from '../../components/Heading';
import AboutHoldingSection from '../../components/AboutHoldingSection';
import HoldingAdvantages from '../../components/HoldingAdvantages';
import Select from '../../components/Select';
import CitySelect from '../../components/CitySelect';
import Button from '../../components/Button';
import CustomLink from "../../components/CustomLink";
import CustomMap from '../../components/CustomMap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setFilterData } from "../../actions/FiltersActions";
import company__rtelecom_xxl from '../../assets/imgs/company__rtelecom--xxl.png';
import heading__about from '../../assets/imgs/er_logo_collage.png';
import heading__about_1024 from '../../assets/imgs/er_logo_collage.png';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadAbout } from '../../actions/AboutActions';
import { loadVacancies } from '../../actions/VacanciesActions';
import { loadScopeActivity } from '../../actions/ScopeActivityActions';
import { loadCompanies } from '../../actions/CompaniesActions';

const mappingScope = (array, newArray) => {
  if (array) {
    for (let i = 0; i < array.length; i++) {
      newArray[i] = {
        label: array[i].name,
        value: array[i].id,
        amount: array[i].vacancy_count
      }
    }
  }
}

class PageAbout extends Component {
  static requestData(store) {
    return requestAll([loadAbout, loadVacancies, loadCompanies, loadScopeActivity], store);
  }
  componentDidMount() {
    this.props.actions.loadAbout();
    this.props.actions.loadVacancies();
    this.props.actions.loadCompanies(this.props.filter);
    this.props.actions.loadScopeActivity(this.props.filter);
  }
  render() {
    let filteredItems = this.props.vacancies;
    const filterName = this.props.filter;
    const filterProperties = ["scope_activity", "employment", "experience", "company"];
    filterProperties.forEach(function(filterBy) {
      let filterValue = filterName[filterBy];
      if (filterValue) {
        filteredItems = filteredItems.filter(function(item) {
          for (let i = 0; i < item[filterBy].length; i++) {
            return item[filterBy][i].id === filterValue;
          }
        });
      }
    });

    const scope_activity = [];
    mappingScope(this.props.scope_activity, scope_activity);
    scope_activity.unshift({label: "Все сферы деятельности", sorting: false});
    const companies = [];
    mappingScope(this.props.companies, companies);
    companies.unshift({label: "Все компании"});

    return (
      <div>
        <Helmet>
          <title>О компании ЭР-Телеком – Ведущая телекоммуникационная компания России</title>
          <meta name="description" content="ЭР-Телеком – одна из крупнейших телеком-компаний России. Мы разрабатываем современные решения и предоставляем интернет, телевидение и связь, делая жизнь людей и других компаний лучше." />
        </Helmet>
        <Heading modifier="heading--fullHeight"
          background={heading__about} //заменено
          background__1024={heading__about_1024} //не заменено, не понимаю в чём разница
          name="Российский телекоммуникационный холдинг"
        />
        <div className="container container--indentVertical">
          <AboutHoldingSection />
        </div>
        <HoldingAdvantages />
        <div className="container holding-sections">
          <div className="holding-sections-wrapper">
              <h2 className="holding-sections__title">Выбирай, что тебе ближе!</h2>
              <Button link="vacancies" text="Показать все вакансии" />
          </div>
          <section className="services">
            <div className="services-container">
              <div className="services-logo"></div>
              <div className="services-content-container">
                <h3 className="services-title">Может быть, сопровождать услуги для физических лиц:</h3>
                <ul className="services-list">
                  <li className="services-list__item">Быстрый Интернет</li>
                  <li className="services-list__item">Кабельное телевидение с разными пакетами каналов</li>
                  <li className="services-list__item">Домашний телефон с дополнительными сервисами</li>
                  <li className="services-list__item">Сервисы Movix в Интернете</li>
                </ul>
                <div className="services-link">
                  <CustomLink
                    to="vacancies"
                    content="Наши вакансии"
                    value={this.props.company && this.props.companies.find(el => el.name === "Дом.ru").id || "10"}
                    label="Дом.ru"
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="business">
          <div className="business-container">
              <div className="business-logo"></div>
              <div className="business-content-container">
                <h3 className="business-title">
                  Или помогать представителям малого и среднего бизнеса – для них «ЭР-Телеком» предоставляет услуги, направленные на цифровизацию производства и бизнес-процессов:
                </h3>
                <ul className="business-list">
                  <li className="business-list__item">Надежный Интернет </li>
                  <li className="business-list__item">Видеонаблюдение</li>
                  <li className="business-list__item">Wi-Fi для бизнеса</li>
                  <li className="business-list__item">Цифровое телевидение</li>
                  <li className="business-list__item">Облачная телефония</li>
                </ul>
                <div className="business-link">
                  <CustomLink
                    to="vacancies"
                    content="Наши вакансии"
                    value={this.props.company && this.props.companies.find(el => el.name === "Дом.ru Бизнес").id || "18"}
                    label="Дом.ru Бизнес"
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="clients">
            <div className="clients-container">
              <div className="clients-logo"></div>
                <div className="clients-content-container">
                  <h3 className="clients-title">А может быть – развивать услуги для федеральных клиентов:</h3>
                  <ul className="clients-list">
                    <li className="clients-list__item">Интернет</li>
                    <li className="clients-list__item">Техподдержка</li>
                    <li className="clients-list__item">Комплекс цифровых услуг и сервисов: видеонаблюдение, облачная телефония, Wi-Fi, ip-телевидение, защита от DDoS-атак, IaaS, антивирусы и многое другое</li>
                  </ul>
                  <div className="clients-link">
                    <CustomLink
                      to="vacancies"
                      content="Наши вакансии"
                      value={this.props.company && this.props.companies.find(el => el.name === "ЭР-Телеком").id || "20"}
                      label="ЭР-Телеком"
                    />
                  </div>
                </div>
            </div>
          </section>
          <section className="government">
            <div className="government-container">
                <div className="government-content-container">
                  <h3 className="government-title">А еще можно стать партнером для государственных заказчиков. Мы ведем работу над следующими проектами: </h3>
                  <div className="government-list-container">
                    <ul className="government-list">
                      <li className="government-list__item">Городской Wi-Fi</li>
                      <li className="government-list__item">Видеонаблюдение</li>
                      <li className="government-list__item">Городское освещение</li>
                      <li className="government-list__item">Безопасный двор</li>
                      <li className="government-list__item">Опорная сеть</li>
                      <li className="government-list__item">Подключение к Интернету социально значимых объектов</li>
                    </ul>
                    <ul className="government-list">
                      <li className="government-list__item">«Умный город»</li>
                      <li className="government-list__item">Диспетчеризация</li>
                      <li className="government-list__item">«Доступная среда»</li>
                      <li className="government-list__item">Система контроля и управления доступом</li>
                    </ul>
                  </div>
                </div>
            </div>
          </section>
          <section className="innovations">
            <div className="innovations-container">
                <div className="innovations-content-container">
                  <h3 className="innovations-title">Инновационные проекты :</h3>
                  <p class="innovations-text">
                      E2E-решения на основе IoT являются одним из элементов инновационных сервисов для клиентов на базе новейших мировых технологий. Мы делаем информацию доступной, общение приятным, а изучение мира легким.
                  </p>
                  <p class="innovations-text">
                      «ЭР-Телеком» является пионером в реализации проектов на базе промышленного Интернета вещей (LoRaWAN). Сегодня в десятках отраслей и компаний тестируются и успешно эксплуатируются решения холдинга.
                  </p>
                </div>
            </div>
          </section>
          {/*Карта России в "о компании"*/}
          {/*<div className="container container--without-paddings container--indentVertical">*/}
          {/*  <h2 className="text text--h2">География ЭР-Телеком Холдинг</h2>*/}
          {/*</div>*/}
        </div>
        {/*<div className="container container--full container--noPaddinngHorizontal container--noPaddinngVertTablet">*/}
        {/*  <CustomMap />*/}
        {/*</div>*/}

        <div className="container container--noPaddinngVertTablet">
          <div className="container container--grayed container--paddingVertical container--indentVertical">
            <CitySelect main="во всех городах" modifier="citySelect--indentBottom citySelect--decrease citySelect--center">Найти работу</CitySelect>
            <div className="row row--smallOffset">
              <div className="col colVertTablet--12">
                <Select name="scopeActivity" value={{label: this.props.filter.scope_activity.label, id: this.props.filter.scope_activity.id}} options={scope_activity} placeholder="Все сферы деятельности" modifier="Select--tell" type="scope_activity" changeOption={this.props.handleChange} alphabeticSort={true} />
              </div>
              <div className="col colVertTablet--12">
                <Select name="companies" value={{label: this.props.filter.company.label, id: this.props.filter.company.id}} options={companies} placeholder="Все компании" type="company" modifier="Select--tell" changeOption={this.props.handleChange} />
              </div>
              <div className="col colVertTablet--12">
                <Button link="/vacancies" text="Найти любимую работу" modifier="button--wide" />
              </div>
          </div>
          </div>
          </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      this.props.actions.loadCompanies(nextProps.filter);
      this.props.actions.loadScopeActivity(nextProps.filter);
    }
  }
}

const mapStateToProps = (state) => {
  return {
      companies: state.companies.list,
      scope_activity: state.scope_activity.list,
      about: state.about.item,
      vacancies: state.vacancies.list,
      filter: state.filter
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({loadAbout, loadVacancies, loadCompanies, loadScopeActivity}, dispatch),
    handleChange: (val, label, type) => {
      dispatch(setFilterData(val, label, type))
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageAbout));



// WEBPACK FOOTER //
// ./src/pages/PageAbout/index.js